export enum EntityType {
  NONE = 'none',
  EVALUATION = 'evaluation',
  SURVEY = 'survey',
}
